import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { DataService } from './data.service';
@Injectable({
    providedIn: 'root'
  })
  export class DashboardService extends DataService{

    private url =environment.apiUrl + 'api/';
    constructor(private httpClient: HttpClient) { 
        super(httpClient);
     }
    getAllApplications(model:any){
      return this.httpClient.post( this.url + 'Application/getApplicationsForGrid', model);
    }
    getAllPayments(model:any){
      return this.httpClient.post( this.url + 'Application/getPaymentsForGrid', model);
    }
    getCurrentLanguage(){
      return this.httpClient.get(this.url+'Language/getCurrent');
    }
    getLocaaddApplicationlizedItems(){
      return this.httpClient.get(this.url + 'Language/getLocalized');
    }
   
  }